/**
 * Customer Edit Modal Validation Schemas
 * Zod schemas for customer edit modals
 */

import { z } from 'zod';

/**
 * Edit Customer Header Modal Schema
 */
export const editCustomerHeaderSchema = z.object({
  customerName: z
    .string()
    .min(1, 'customer.validation.customerNameRequired')
    .max(200, 'customer.validation.customerNameMax'),
  alternativeName: z
    .string()
    .max(200, 'customer.validation.alternativeNameMax')
    .optional()
    .or(z.literal('')),
  nickname: z
    .string()
    .max(100, 'customer.validation.nicknameMax')
    .optional()
    .or(z.literal('')),
  type: z.enum(['company', 'individual'], {
    required_error: 'customer.validation.customerTypeRequired',
  }),
  categoryIds: z.array(z.number()).min(1, 'customer.validation.categoryRequired'),
});

/**
 * Edit Financial Info Modal Schema
 */
export const editCustomerFinancialInfoSchema = z.object({
  // Payment Terms
  agreedTerms: z.enum(['ETA', 'ETD', 'EOM', 'Net', 'COD', 'Receipt', 'DAD']).optional(),
  dueInDays: z.number().int().min(0, 'customer.validation.invalidFormat').optional(),

  // Hold Status - uses new API spec values
  hold: z.enum(['none', 'credit_hold', 'order_hold', 'ship_hold', 'all_hold'], {
    required_error: 'customer.validation.holdRequired',
  }),

  // Tax Information
  taxType: z.enum(['GST', 'VAT', 'BusinessIncomeTax']).optional(),
  taxRate: z
    .number()
    .min(0, 'customer.validation.invalidFormat')
    .max(100, 'customer.validation.invalidFormat')
    .optional(),
});

/**
 * Type exports
 */
export type EditCustomerHeaderFormData = z.infer<typeof editCustomerHeaderSchema>;
export type EditCustomerFinancialInfoFormData = z.infer<typeof editCustomerFinancialInfoSchema>;
